import EmblaCarousel from 'embla-carousel';

export function initTilesColumnGridSlider() {
    const sliderElements = document.querySelectorAll('.js-tiles-column-grid-slider');

    if (!sliderElements.length) return;

    const sliders = Array.from(sliderElements)
        .map((sliderElement) => {
            const sliderContainer = sliderElement.parentElement;
            const blockContainer = sliderContainer?.parentElement?.parentElement;
            const viewport = sliderElement.querySelector('.embla__viewport');
            const dotsContainer = blockContainer?.querySelector('.embla-tilescolumngridblock-pagination');
            const prevBtn = sliderContainer?.querySelector('.c_swiper-tilescolumngridblock-prev');
            const nextBtn = sliderContainer?.querySelector('.c_swiper-tilescolumngridblock-next');

            if (!viewport) return null;

            let embla = null;
            const enableDesktopCarousel = sliderElement.dataset.enableDesktopCarousel === 'true';

            const handlePrevClick = () => {
                if (embla) embla.scrollPrev();
            };

            const handleNextClick = () => {
                if (embla) embla.scrollNext();
            };

            function updateDots() {
                if (!dotsContainer || !embla) return;
                const index = embla.selectedScrollSnap();
                dotsContainer.querySelectorAll('.swiper-pagination-bullet').forEach((dot, i) => {
                    dot.classList.toggle('swiper-pagination-bullet-active', i === index);
                });
            }

            function buildDots() {
                if (!dotsContainer || !embla) return;
                dotsContainer.innerHTML = '';
                embla.scrollSnapList().forEach((_, i) => {
                    const dot = document.createElement('button');
                    dot.className = 'swiper-pagination-bullet';
                    dot.type = 'button';
                    dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
                    dot.addEventListener('click', () => embla && embla.scrollTo(i));
                    dotsContainer.appendChild(dot);
                });
                updateDots();
            }

            function initEmbla() {
                const shouldEnableCarousel = window.innerWidth < 768 || enableDesktopCarousel;

                if (shouldEnableCarousel && !embla) {
                    embla = EmblaCarousel(viewport, {
                        align: 'start',
                        slidesToScroll: 1,
                        loop: false,
                        dragFree: false,
                    });

                    buildDots();
                    embla.on('select', updateDots);

                    if (prevBtn) prevBtn.addEventListener('click', handlePrevClick);
                    if (nextBtn) nextBtn.addEventListener('click', handleNextClick);
                } else if (!shouldEnableCarousel && embla) {
                    if (prevBtn) prevBtn.removeEventListener('click', handlePrevClick);
                    if (nextBtn) nextBtn.removeEventListener('click', handleNextClick);
                    embla.destroy();
                    embla = null;
                    if (dotsContainer) dotsContainer.innerHTML = '';
                }
            }

            return initEmbla;
        })
        .filter(Boolean);

    const initAll = () => {
        sliders.forEach((initSlider) => initSlider());
    };

    initAll();
    window.addEventListener('resize', initAll);
}
